(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FontStager", [], factory);
	else if(typeof exports === 'object')
		exports["FontStager"] = factory();
	else
		root["FontStager"] = factory();
})(window, function() {
return 